import styled from "styled-components";

export const BillingDataContainer = styled.div`
  width: 100%;
  // min-height: 480px;
  position: relative;
  margin-left: auto;
  margin-right: auto;
`;
export const BillingDataContainerBilling = styled.div`
  width: 100%;
  min-height: 50px;
  position: relative;
  margin-top: 10px;
`;
export const BillingDataContainerBillingTab = styled.div`
  width: 95%;
  height: 37px;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  justify-content: space-around;
  align-items: center;
  border: 0.6px solid rgba(61, 61, 61, 0.131);
  border-radius: 3px;
  margin-top: 10px;

  p {
    color: black;
    width: 85%;
    height: 23px;
    font-size: 18px;
    font-family: "Akrobat";
    position: relative;
    display: flex;
    justify-content: flex-start;

    h1 {
      width: 30px;
      height: 30px;
      border-radius: 15px;
      font-size: 24px;
      position: relative;
      top: -4px;
      font-family: "Akrobat ExtraBold";
      padding-left: 0px;
      color: white;
      background-color: #80bd01;
      margin-left: 8px;
      margin-right: 8px;

      &:nth-child(1) {
        padding-left: 10px;
      }
    }
  }
`;
export const BillingDataContainerBillingContent = styled.div`
  width: 95%;
  height: 315px;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  margin-top: 25px;
  display: flex;
  left: 0px;
  justify-content: space-around;
  align-items: center;
  // background-color: #80bd01;
`;
export const BillingDataContainerBillingContentCard = styled.div`
  width: 400px;
  height: 330px;
  border: 1px solid rgba(61, 61, 61, 0.131);
  border-radius: 4px;
  box-shadow: 2px 2px 5px 2px rgb(220, 220, 220);
  transition: 0.3s;
  &:hover {
    transition: 0.3s;
    transform: scale(1.01, 1.01);
  }
`;
export const BillingDataContainerBillingContentCardHeader = styled.div`
  width: 100%;
  height: 60px;
  position: relative;
  display: flex;
  align-items: center;
  p {
    font-size: 18px;
    font-family: "Akrobat ExtraBold";
    letter-spacing: 0.03rem;
    color: #ff7e00;
    padding-left: 20px;
  }
`;
export const BillingDataContainerBillingContentCardContent = styled.div`
  width: 360px;
  height: 220px;
  position: relative;
  margin-left: auto;
  margin-right: auto;
`;
export const BillingDataContainerBillingContentCardContentBody = styled.div`
  width: 100%;
  min-height: 220px;
  position: relative;
  float: left;
`;
export const BillingDataContainerBillingContentCardContentBodyRow = styled.div`
  width: 100%;
  height: auto;
  margin-top: 5px;
  display: flex;
  justify-content: flex-start;

  p {
    font-size: 17px;
    font-family: "Akrobat";
    letter-spacing: 0.03rem;
    color: rgb(61,61,61);
    strong {
      font-family: "Akrobat ExtraBold";
    }
    &:nth-child(2) {
      margin-left: 10px;
    }
    &:nth-child(3) {
      margin-left: 10px;
    }
  }
`;
export const BillingDataContainerBillingContentCardContentFooter = styled.div`
  width: 100%;
  height: 33px;
  position: relative;
  float: left;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;
export const BillingDataContainerBillingContentCardContentButton = styled.div`
  width: 80px;
  height: 25px;
  position: relative;
  display: flex;
  cursor: pointer;
align-items: center;
  p {
    font-size: 20px;
    font-family: "Akrobat SemiBold";
    letter-spacing: 0.03rem;
    color: black;
    margin-left: 5px;
  }
`;
